import React, { useEffect, useState } from "react"; // Import useRef
import { useParams } from "react-router-dom";

import { useDispatch } from "react-redux";

import {
  Avatar,
  Box,
  Chip,
  Divider,
  Grid,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Slider,
  Tab,
  Tabs,
  Typography,
  List,
  CircularProgress,
  Paper,
  IconButton,
  Select,
  MenuItem,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";

import {
  getAuditById,
  preFillAuditForm,
  refreshVideoState,
} from "../../../redux/slices/tenant.slice";

import {
  setHeaderTitle,
  setSnackbar,
} from "../../../redux/slices/common.slice";

import "../../../styles/forms.css";

import ReactPlayer from "react-player";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { FaCircleChevronLeft, FaCircleChevronRight } from "react-icons/fa6";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import EditForm from "./editForm";
const TabPanel = ({ children, value, index, ...other }) => (
  <div role="tabpanel" hidden={value !== index} {...other}>
    {value === index && (
      <Box
        sx={{
          padding: "4px 12px",
          // height: "calc(100vh - 300px)",
          // overflowY: "auto",
        }}
      >
        {children}
      </Box>
    )}
  </div>
);

const customStyles = {
  "& .MuiInputBase-input.MuiOutlinedInput-input": {
    background: "#FFFFFF",
    borderRadius: "8px",
    boxShadow: "none !important",
    border: "1px solid #0D333F54",
    cursor: "pointer",
    padding: "6px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none !important",
  },
};

const ProcessingCard = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        textAlign: "center",
      }}
    >
      <HourglassEmptyIcon
        sx={{
          fontSize: 60,
          color: "#64bcd2",
          mb: 1,
          animation: "rotate 1.5s linear infinite",
        }}
      />
      <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
        Processing...
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 1,
            "@keyframes wave": {
              "0%, 100%": { transform: "scale(1)" },
              "50%": { transform: "scale(1.5)" },
            },
          }}
        >
          {[...Array(3)].map((_, index) => (
            <Box
              key={index}
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: "#64bcd2",
                animation: "wave 1.2s infinite",
                animationDelay: `${index * 0.2}s`,
              }}
            />
          ))}
        </Box>
      </Box>
      <Typography variant="subtitle1" sx={{ mt: 2 }}>
        Your request is being processed. Please Wait for few minutes.
      </Typography>
    </Box>
  );
};

export default function AuditDetailPage() {
  const [mediaData, setMediaData] = useState([]);
  const [selectedMedia, setSelectedMedia] = useState();
  const [player, setPlayer] = useState(null);
  const [isGalleryOpen, setIsGalleryOpen] = useState(true);
  const [selectedKeyword, setSelectedKeyword] = useState();
  const [selectedTopic, setSelectedTopic] = useState();
  const [selectedlabel, setSelectedlabel] = useState();

  const [videoDuration, setVideoDuration] = useState(0);
  const [sliderValue, setSliderValue] = useState(0); // for current slider value
  const [sliderWidth, setSliderWidth] = useState(0); // to get width of the slider for calculating strip width
  const [activeTab, setActiveTab] = useState(0);
  const [alignment, setAlignment] = React.useState("videos");
  const [images, setImages] = useState([]);
  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  const [loading, setLoading] = useState(false);
  const [mediaLoading, setMediaLoading] = useState(true);
  const [pollingActive, setPollingActive] = useState(true);
  const dispatch = useDispatch();

  const [currentTime, setCurrentTime] = useState(0); // State to store current time

  const [auditDetails, setAuditDetails] = useState();
  const [token, setToken] = useState();
  const { auditId } = useParams();

  const fetchAuditDetailsById = async () => {
    setLoading(true);

    try {
      let response = await dispatch(
        getAuditById({
          id: auditId,
        })
      );
      const { payload } = response;
      if (payload?.status) {
        setAuditDetails(payload?.data);
      } else {
        await dispatch(
          setSnackbar({
            open: true,
            severity: "error",
            message: payload?.message || "Internal server error",
          })
        );
      }
    } catch (error) {
      await dispatch(
        setSnackbar({
          open: true,
          severity: "error",
          message: "Internal server error",
        })
      );
    }

    setLoading(false);
  };
  const prefillForm = async () => {
    setLoading(true);

    try {
      let response = await dispatch(
        preFillAuditForm({
          id: auditDetails?.inspection_id,
        })
      );
      const { payload } = response;
      if (payload?.status) {
        fetchAuditDetailsById();
      } else {
        // await dispatch(
        //   setSnackbar({
        //     open: true,
        //     severity: "error",
        //     message: payload?.message || "Internal server error",
        //   })
        // );
      }
    } catch (error) {
      // await dispatch(
      //   setSnackbar({
      //     open: true,
      //     severity: "error",
      //     message: "Internal server error",
      //   })
      // );
    }

    setLoading(false);
  };

  useEffect(() => {
    if (!pollingActive && !auditDetails?.is_prefill) {
      prefillForm();
    }
  }, [pollingActive, auditDetails]);
  useEffect(() => {
    fetchAuditDetailsById();
  }, []);
  // useEffect(() => {
  //   if (!pollingActive) fetchAuditDetailsById();
  // }, [pollingActive]);

  useEffect(() => {
    if (auditDetails) dispatch(setHeaderTitle(auditDetails?.title));
    else {
      dispatch(setHeaderTitle(""));
    }
  }, [auditDetails]);
  const timeToSeconds = (timeString) => {
    const [hours, minutes, secondsWithMillis] = timeString.split(":");

    const [seconds, milliseconds = 0] = secondsWithMillis.split(".");

    const totalSeconds =
      parseInt(hours, 10) * 3600 + // Hours to seconds
      parseInt(minutes, 10) * 60 + // Minutes to seconds
      parseInt(seconds, 10) + // Seconds
      (parseInt(milliseconds, 10) || 0) / 1000; // Milliseconds to seconds

    return totalSeconds;
  };
  const getVideoTranslationData = async () => {
    try {
      const response = await dispatch(
        refreshVideoState({ id: auditDetails?.inspection_id })
      );
      const { payload } = response;
      if (payload?.status) {
        let newData = payload?.data?.map((video, index) => {
          return {
            id: video?.id,
            title: "Track - " + (index + 1),
            url: `${video?.video_url}?${payload?.token}`,
            status: video?.status,
            transcription:
              video?.video_insights?.videos[0]?.insights?.transcript?.map(
                (item) => ({
                  id: item?.id,
                  text: item?.text,
                  timeframes: item?.instances?.map((item) => ({
                    start: timeToSeconds(item?.start),
                    end: timeToSeconds(item?.end),
                  })),
                })
              ),
            topics: video?.video_insights?.summarizedInsights?.topics?.map(
              (item) => ({
                id: item.id,
                topic: item?.name,
                timeframes: item?.appearances?.map((item) => ({
                  start: item?.startSeconds,
                  end: item?.endSeconds,
                })),
              })
            ),
            keywords: video?.video_insights?.summarizedInsights?.keywords?.map(
              (item) => ({
                id: item.id,
                keyword: item?.name,
                timeframes: item?.appearances?.map((item2) => ({
                  start: Math.floor(item2?.startSeconds),
                  end: Math.ceil(item2?.endSeconds),
                })),
              })
            ),
            labels: video?.video_insights?.summarizedInsights?.labels?.map(
              (item) => ({
                id: item.id,
                label: item?.name,
                timeframes: item?.appearances?.map((item2) => ({
                  start: Math.floor(item2?.startSeconds),
                  end: Math.ceil(item2?.endSeconds),
                })),
              })
            ),
          };
        });
        if (newData && newData?.length > 0) setMediaData(newData);
        setImages(payload?.images);
        setToken(payload?.token);
        const allProcessedOrFailed = newData.every(
          (video) => video.status === "Processed" || video.status === "Failed"
        );
        if (allProcessedOrFailed) {
          setPollingActive(false); // Stop polling if all videos are processed
        }

        // Set the first media item as selected if none is selected
        if (!selectedMedia) {
          setSelectedMedia(newData[0]);
        }
      } else {
        await dispatch(
          setSnackbar({
            open: true,
            severity: "error",
            message: payload?.message || "Internal server error",
          })
        );
      }
    } catch (e) {
      await dispatch(
        setSnackbar({
          open: true,
          severity: "error",
          message: "Internal server error",
        })
      );
    } finally {
      setMediaLoading(false);
    }
  };

  useEffect(() => {
    if (auditDetails) getVideoTranslationData();
  }, [auditDetails]);
  useEffect(() => {
    if (pollingActive && auditDetails) {
      const intervalId = setInterval(() => {
        getVideoTranslationData();
      }, 60000); // 2.5 minutes interval

      return () => clearInterval(intervalId);
    }
  }, [pollingActive, auditDetails]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleSeek = (time) => {
    if (player) player.seekTo(time, "seconds");
  };

  const toggleGallery = () => {
    setIsGalleryOpen(!isGalleryOpen);
  };

  const handleKeywordClick = (keyword) => {
    setSelectedKeyword(keyword);
  };
  const handleEntityClick = (keyword) => {
    setSelectedlabel(keyword);
  };

  const handleDuration = (duration) => {
    setVideoDuration(duration);
  };

  const handleSliderChange = (event, newValue) => {
    setSliderValue(newValue);
    handleSeek(newValue);
  };

  // Convert time in seconds to mm:ss format
  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const handleSliderRef = (slider) => {
    if (slider) {
      const width = slider.offsetWidth;

      setSliderWidth(width);
    }
  };
  const handleSkipTotranscription = (transcription) => {
    if (transcription?.timeframes && transcription?.timeframes?.length > 0) {
      let startTime = transcription?.timeframes[0]?.start;
      console.log(startTime);
      handleSeek(startTime);
    }
  };

  const calculateTrackColorPosition = (timeframe) => {
    if (!sliderWidth || !videoDuration) {
      console.error("Slider width or video duration not set");
      return { startPos: 0, endPos: 0 };
    }

    const startPos = (timeframe.start / videoDuration) * sliderWidth;
    const endPos = (timeframe.end / videoDuration) * sliderWidth;

    // Ensure positions are within slider bounds
    return {
      startPos: Math.min(Math.max(startPos, 0), sliderWidth),
      endPos: Math.min(Math.max(endPos, 0), sliderWidth),
    };
  };

  // This function will be triggered on every progress update of the video
  const handleProgress = (progress) => {
    setCurrentTime(progress.playedSeconds); // Current time in seconds
  };

  const TimeLine = (item) => {
    return (
      <Box sx={{ position: "relative" }} mt={2}>
        {/* Slider */}
        <Slider
          value={sliderValue}
          min={0}
          max={videoDuration}
          step={0.1}
          onChange={handleSliderChange}
          sx={{
            width: "100%",
            color: "#ddd",
            height: 15,
            padding: "0 !important",

            "& .MuiSlider-thumb": {
              display: "block", // Make the thumb visible

              zIndex: 3, // Ensure it's above the highlighted section
            },

            "& .MuiSlider-track": {
              zIndex: 1, // Below the highlighted section
            },

            "& .MuiSlider-rail": {
              zIndex: 1, // Below the highlighted section
            },
          }}
          ref={handleSliderRef}
          valueLabelDisplay="auto"
          valueLabelFormat={(value) => formatTime(value)}
        />
        {/* Mark start and end times, and color in-between */}
        {item?.timeframes.map((timeframe, index) => {
          const { startPos, endPos } = calculateTrackColorPosition(timeframe);

          const handleBoxClick = (e) => {
            const offsetX = e.nativeEvent.offsetX; // Get the clicked position relative to the box
            const boxStartPos = e.target.offsetLeft; // Get the position of the box relative to the entire slider

            // Calculate the new value of the slider based on the click position
            const newValue =
              ((offsetX + boxStartPos) / sliderWidth) * videoDuration;

            handleSliderChange(null, newValue);
          };

          return (
            <Box
              key={index}
              sx={{
                position: "absolute",
                left: startPos,
                width: endPos - startPos,
                height: 16,
                top: 0,
                backgroundColor: "#036185", // Color for the highlighted section
                zIndex: 2, // Above the slider track but below the thumb
                pointerEvents: "auto",
              }}
              onClick={handleBoxClick} // Trigger onClick event when clicked
            />
          );
        })}
      </Box>
    );
  };

  const isInTimeframe = (timeframes, currentTime) => {
    return timeframes?.some(
      (frame) => currentTime >= frame.start && currentTime <= frame.end
    );
  };

  return (
    <>
      <Box>
        {mediaLoading ? (
          <Box sx={{ height: "calc(100vh - 205px)" }} className="center">
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={2}>
            {/* Right Side: Player and Details */}
            <Grid item xs={12} md={pollingActive ? 12 : 5}>
              <Box
                className="box-container"
                // sx={{ height: "calc(100vh - 180px)" }}
              >
                <Box className="space-between">
                  <Select
                    sx={customStyles}
                    name="status"
                    className="basic-multi-select basic-multi-select-status"
                    onChange={(event) => {
                      setSelectedMedia(
                        mediaData?.find(
                          (item) => +item.id === +event.target.value
                        )
                      );
                    }}
                    value={selectedMedia?.id}
                    classNamePrefix="select"
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  >
                    {mediaData.map((item) => (
                      <MenuItem value={item?.id}>{item.title}</MenuItem>
                    ))}
                  </Select>
                  <ToggleButtonGroup
                    color="primary"
                    value={alignment}
                    exclusive
                    onChange={handleChange}
                    aria-label="Platform"
                    size="small"
                  >
                    <ToggleButton value="videos">Videos</ToggleButton>
                    <ToggleButton value="images">Images</ToggleButton>
                  </ToggleButtonGroup>
                </Box>
                <Box
                  sx={{
                    height: pollingActive
                      ? "calc(100vh - 200px)"
                      : "calc(100vh - 280px)",
                    overflowY: "auto",
                  }}
                  mt={2}
                >
                  {alignment === "videos" ? (
                    <>
                      {selectedMedia?.status === "Processing" && (
                        <ProcessingCard />
                      )}
                      {selectedMedia?.status === "Failed" && (
                        <Box>Failed ...</Box>
                      )}
                      {selectedMedia?.status === "Processed" && (
                        <Grid container spacing={2}>
                          {/* Video Player */}
                          <Grid item xs={!isGalleryOpen ? 6 : 12}>
                            <ReactPlayer
                              url={selectedMedia?.url}
                              controls
                              width="100%"
                              height={isGalleryOpen ? "280px" : "100%"}
                              ref={(playerInstance) =>
                                setPlayer(playerInstance)
                              }
                              onDuration={handleDuration}
                              onProgress={handleProgress}
                            />
                          </Grid>

                          {/* Transcription and Keywords */}
                          <Grid item xs={!isGalleryOpen ? 6 : 12}>
                            <Tabs
                              value={activeTab}
                              onChange={handleTabChange}
                              aria-label="TODO tabs"
                              className="configure-action-tab"
                            >
                              <Tab label={"Transcriptions"} />
                              <Tab label={"Insights"} />
                            </Tabs>
                            <TabPanel value={activeTab} index={0}>
                              {selectedMedia?.transcription &&
                              selectedMedia?.transcription?.length !== 0 ? (
                                <List>
                                  {selectedMedia?.transcription?.map(
                                    (segment, index) => {
                                      // If the transcription is within the current time range, display it
                                      return (
                                        <ListItem
                                          key={index}
                                          button
                                          sx={{
                                            marginBottom: 1,
                                            backgroundColor: isInTimeframe(
                                              segment.timeframes,
                                              currentTime
                                            )
                                              ? "#64bcd2"
                                              : "#f1f1f1",
                                            color: isInTimeframe(
                                              segment.timeframes,
                                              currentTime
                                            )
                                              ? "white"
                                              : "black",
                                            transition: "all 0.3s ease", // Smooth transition for hover effect
                                            "&:hover": {
                                              backgroundColor: isInTimeframe(
                                                segment.timeframes,
                                                currentTime
                                              )
                                                ? "#4ca3ba" // Slightly darker shade for active item hover
                                                : "#e0e0e0", // Slightly darker shade for inactive item hover
                                              color: isInTimeframe(
                                                segment.timeframes,
                                                currentTime
                                              )
                                                ? "white"
                                                : "black", // Ensure text remains visible
                                            },
                                          }}
                                          onClick={() =>
                                            handleSkipTotranscription(segment)
                                          }
                                        >
                                          <PlayCircleIcon
                                            sx={{
                                              marginRight: 1,
                                              color: "#036185",
                                            }}
                                          />
                                          <Box>
                                            <Typography
                                              variant="caption"
                                              sx={{
                                                display: "block",
                                                color: isInTimeframe(
                                                  segment.timeframes,
                                                  currentTime
                                                )
                                                  ? "white"
                                                  : "#757575", // Subtle color for time
                                                fontSize: "0.8rem",
                                                marginBottom: "0.2rem",
                                              }}
                                            >
                                              {formatTime(
                                                segment.timeframes[0].start
                                              )}{" "}
                                              -{" "}
                                              {formatTime(
                                                segment.timeframes[0].end
                                              )}
                                            </Typography>
                                            <ListItemText
                                              primary={segment.text}
                                            />
                                          </Box>
                                        </ListItem>
                                      );
                                    }
                                  )}
                                </List>
                              ) : (
                                <Typography variant="subtitle1" mt={2}>
                                  No Transcriptions Generated
                                </Typography>
                              )}
                            </TabPanel>
                            <TabPanel value={activeTab} index={1}>
                              <Grid item xs={12}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ marginBottom: 1, fontWeight: 500 }}
                                >
                                  Topics
                                </Typography>
                                {selectedMedia?.topics &&
                                selectedMedia?.topics?.length > 0 ? (
                                  <>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        gap: 1,
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      {selectedMedia?.topics?.map(
                                        (topic, index) => (
                                          <Chip
                                            key={index}
                                            label={topic.topic}
                                            sx={{
                                              cursor: "pointer",
                                              fontSize: "14px !important",

                                              color: "#fff",
                                              "&:hover": {
                                                backgroundColor: "#b6877a",
                                              },
                                            }}
                                            style={{
                                              backgroundColor:
                                                topic.topic ===
                                                selectedTopic?.topic
                                                  ? "#64bcd2"
                                                  : "",
                                            }}
                                            onClick={() =>
                                              setSelectedTopic(topic)
                                            }
                                          />
                                        )
                                      )}
                                    </Box>
                                    {TimeLine(selectedTopic)}
                                  </>
                                ) : (
                                  <Typography variant="subtitle1">
                                    No Topics Found
                                  </Typography>
                                )}
                              </Grid>
                              <Grid xs={12}>
                                <Divider sx={{ margin: "8px 0" }} />
                              </Grid>
                              <Grid item xs={12}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ marginBottom: 1, fontWeight: 500 }}
                                >
                                  Keywords
                                </Typography>
                                {selectedMedia?.keywords &&
                                selectedMedia?.keywords?.length > 0 ? (
                                  <>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        gap: 1,
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      {selectedMedia?.keywords?.map(
                                        (keyword, index) => {
                                          return (
                                            <Chip
                                              key={index}
                                              label={keyword.keyword}
                                              sx={{
                                                cursor: "pointer",
                                                fontSize: "14px !important",
                                                padding: "0 !important",
                                                color: "#fff",
                                                "&:hover": {
                                                  backgroundColor: "#b6877a",
                                                },
                                              }}
                                              style={{
                                                backgroundColor:
                                                  keyword.keyword ===
                                                  selectedKeyword?.keyword
                                                    ? "#64bcd2"
                                                    : "",
                                              }}
                                              onClick={() =>
                                                handleKeywordClick(keyword)
                                              }
                                            />
                                          );
                                        }
                                      )}
                                    </Box>
                                    {TimeLine(selectedKeyword)}
                                  </>
                                ) : (
                                  <Typography variant="subtitle1">
                                    No Keywords Found
                                  </Typography>
                                )}
                              </Grid>
                              <Grid xs={12}>
                                <Divider sx={{ margin: "8px 0" }} />
                              </Grid>
                              <Grid item xs={12}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ marginBottom: 1, fontWeight: 500 }}
                                >
                                  Labels
                                </Typography>
                                {selectedMedia?.labels &&
                                selectedMedia?.labels?.length > 0 ? (
                                  <>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        gap: 1,
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      {selectedMedia?.labels?.map(
                                        (label, index) => (
                                          <Chip
                                            key={index}
                                            label={label.label}
                                            sx={{
                                              cursor: "pointer",
                                              fontSize: "14px !important",
                                              padding: "0 !important",
                                              color: "#fff",
                                              "&:hover": {
                                                backgroundColor: "#b6877a",
                                              },
                                            }}
                                            style={{
                                              backgroundColor:
                                                label.label ===
                                                selectedlabel?.label
                                                  ? "#64bcd2"
                                                  : "",
                                            }}
                                            onClick={() =>
                                              handleEntityClick(label)
                                            }
                                          />
                                        )
                                      )}
                                    </Box>
                                    {TimeLine(selectedlabel)}
                                  </>
                                ) : (
                                  <Typography variant="subtitle1">
                                    No Labels Found
                                  </Typography>
                                )}
                              </Grid>
                            </TabPanel>
                          </Grid>

                          {/* Keywords */}
                        </Grid>
                      )}
                    </>
                  ) : (
                    <>
                      {images && images?.length === 0 ? (
                        <Box className="center" sx={{ height: "100%" }}>
                          <Typography variant="subtitle1" sx={{ mt: 2 }}>
                            No images Found
                          </Typography>
                        </Box>
                      ) : (
                        <Grid container spacing={2}>
                          {images?.map((item) => (
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                              <img
                                src={`${item.image_url}?${token}`}
                                alt="img"
                                height="100%"
                                width="auto"
                              />
                            </Grid>
                          ))}
                        </Grid>
                      )}
                    </>
                  )}
                </Box>
              </Box>
            </Grid>
            {!pollingActive && (
              <Grid item xs={12} md={7}>
                {auditDetails?.inspection_id && (
                  <EditForm
                    form_id={auditDetails?.inspection_id}
                    mode="edit"
                    // height="calc(100vh - 120px)"
                  />
                )}
              </Grid>
            )}
          </Grid>
        )}
      </Box>
    </>
  );
}
